import { getIsMultiLanguageEnabled, tryParseLocaleParam } from "@mivo/i18n";

const ALLOWED_MARKET_COUNTRIES = new Set(["BR", "GB", "ES", "DE", "PT"]);

function normalizeLocaleParam(locale?: string | null): string | null {
  if (!locale) {
    return null;
  }
  return tryParseLocaleParam(locale);
}

function normalizeMarketCountryParam(marketCountry?: string | null): string | null {
  if (!marketCountry) {
    return null;
  }
  return ALLOWED_MARKET_COUNTRIES.has(marketCountry) ? marketCountry : null;
}

/** Appends cross-host locale and market country params when target host differs from current document host. */
export function appendCrossHostLocaleParam(
  resolvedUrl: string,
  locale?: string | null,
  marketCountry?: string | null,
  currentHref?: string,
): string {
  const normalizedLocale = getIsMultiLanguageEnabled()
    ? normalizeLocaleParam(locale)
    : "pt-BR";
  const normalizedMarketCountry = getIsMultiLanguageEnabled()
    ? normalizeMarketCountryParam(marketCountry)
    : "BR";
  if (!normalizedLocale && !normalizedMarketCountry) {
    return resolvedUrl;
  }

  let target: URL;
  try {
    target = new URL(resolvedUrl);
  } catch {
    return resolvedUrl;
  }

  if (typeof window !== "undefined" || currentHref) {
    try {
      const current = new URL(currentHref ?? window.location.href);
      if (target.host === current.host && target.protocol === current.protocol) {
        return resolvedUrl;
      }
    } catch {
      return resolvedUrl;
    }
  }

  if (normalizedLocale) {
    target.searchParams.set("locale", normalizedLocale);
  }
  if (normalizedMarketCountry) {
    target.searchParams.set("marketCountry", normalizedMarketCountry);
  }
  return target.toString();
}
